import { useLocation, useParams } from 'react-router';

const useRequesterId = () => {
	const { requesterId } = useParams();
	const location = useLocation();

	if (requesterId) {
		return requesterId;
	}

	return new URLSearchParams(location.search.toLowerCase()).get('requesterid');
};

export default useRequesterId;
